import { IconSVG } from '../types';

export const SentimentStressed = ({ size, style }: IconSVG) => {
  return (
    <svg 
      xmlns="http://www.w3.org/2000/svg" 
      width={size}
      height={size}
      style={style}
      fill="none" 
      viewBox="0 0 24 24">
      <path
        fill="currentColor"
        d="m12 15.55 1.15 1.15a.48.48 0 0 0 .7 0L15 15.55l.45.45a.72.72 0 0 0 .525.225A.72.72 0 0 0 16.5 16a.72.72 0 0 0 .225-.525.72.72 0 0 0-.225-.525l-1.15-1.15a.48.48 0 0 0-.7 0l-1.15 1.15-1.15-1.15a.48.48 0 0 0-.7 0l-1.15 1.15-1.15-1.15a.48.48 0 0 0-.7 0L7.5 14.95a.72.72 0 0 0-.225.525q0 .3.225.525a.72.72 0 0 0 .525.225A.72.72 0 0 0 8.55 16l.45-.45 1.15 1.15a.48.48 0 0 0 .7 0zM8.475 10l-1.3.95a.85.85 0 0 0-.312.5q-.063.3.137.55t.5.313.55-.138l2.425-1.775q.2-.15.2-.4t-.2-.4L8.05 7.825a.64.64 0 0 0-.55-.138A.85.85 0 0 0 7 8a.67.67 0 0 0-.15.55q.05.3.325.5zm7.05 0 1.3-.95q.25-.2.313-.5A.64.64 0 0 0 17 8a.85.85 0 0 0-.5-.312.64.64 0 0 0-.55.137L13.525 9.6q-.2.15-.2.4t.2.4l2.425 1.775q.25.2.55.137A.85.85 0 0 0 17 12a.67.67 0 0 0 .15-.55.76.76 0 0 0-.325-.5zM12 22a9.7 9.7 0 0 1-3.9-.788 10.1 10.1 0 0 1-3.175-2.137q-1.35-1.35-2.137-3.175A9.7 9.7 0 0 1 2 12q0-2.075.788-3.9a10.1 10.1 0 0 1 2.137-3.175q1.35-1.35 3.175-2.137A9.7 9.7 0 0 1 12 2q2.075 0 3.9.788a10.1 10.1 0 0 1 3.175 2.137q1.35 1.35 2.137 3.175A9.7 9.7 0 0 1 22 12a9.7 9.7 0 0 1-.788 3.9 10.1 10.1 0 0 1-2.137 3.175q-1.35 1.35-3.175 2.137A9.7 9.7 0 0 1 12 22m0-2q3.35 0 5.675-2.325T20 12t-2.325-5.675T12 4 6.325 6.325 4 12t2.325 5.675T12 20"
       />
    </svg>
  );
};
